const buyerZh = {
  BUYER_PORTAL_TITLE_LEGACY: '采购方门户',
  TOPBAR_AVATAR_TOOLTIP: '{{name}} · 个人资料',
  SIGN_IN_SUBTITLE: '登录以查看订单并继续购物。',
  FORGOT_PASSWORD: '忘记密码？',
  FORGOT_PASSWORD_TITLE: '重置密码',
  FORGOT_PASSWORD_DESC: '请输入你账号绑定的邮箱，我们会发送重置密码链接到你的邮箱。',
  SEND_RESET_LINK: '发送重置链接',
  FORGOT_PASSWORD_SENT: '已发送！请到邮箱查收重置密码链接。',
  FORGOT_PASSWORD_FAILED: '发送失败，请稍后重试。',
  RESET_PASSWORD_TITLE: '重置密码',
  RESET_PASSWORD_DESC: '请为你的账号设置新密码。',
  RESET_PASSWORD_SUBMIT: '重置密码',
  RESET_PASSWORD_SUCCESS: '密码已更新，现在可以使用新密码登录。',
  RESET_PASSWORD_FAILED: '重置失败，链接可能已过期。',
  RESET_PASSWORD_MISSING_TOKEN: '重置链接无效或已过期，请重新申请。',
  BACK_TO_LOGIN: '返回登录',
  NEW_PASSWORD: '新密码',
  CONFIRM_PASSWORD: '确认密码',
  PLEASE_ENTER_NEW_PASSWORD: '请输入新密码',
  PLEASE_CONFIRM_PASSWORD: '请再次输入新密码',
  PASSWORDS_DO_NOT_MATCH: '两次输入的密码不一致',
  SUBMITTING: '提交中…',
  PAGE_TITLE_RESET_PASSWORD: '重置密码',
  CHANGE_PASSWORD: '修改密码',
  CURRENT_PASSWORD: '当前密码',
  CHANGE_PASSWORD_SUCCESS: '密码已更新。',
  CHANGE_PASSWORD_WRONG_CURRENT: '当前密码不正确。',
  CHANGE_PASSWORD_FAILED: '修改密码失败。',
  EMAIL: '邮箱',
  PLEASE_ENTER_EMAIL: '请输入邮箱',
  SIGNING_IN: '登录中…',
  SIGN_OUT: '退出登录',
  LOGIN_SUCCESS: '登录成功',
  LOGIN_FAILED: '登录失败',
  LOGIN_BRAND_EYEBROW: '480+ 商家信赖之选',
  LOGIN_BRAND_TAGLINE: '医疗用品，安心订购。',
  LOGIN_BRAND_BLURB: '实时仓库库存，不预订、不超卖，仅为今日货架上的商品付款。',
  LOGIN_WELCOME_BACK: '欢迎回来',
  KEEP_SIGNED_IN: '在此设备上保持登录',
  OR: '或',
  NEW_TO_VMALL: '初次使用 VMall？',
  REGISTER_YOUR_CLINIC: '注册账号',
  OR_BROWSE_AS_GUEST: '或',

  REGISTER_PAGE_TITLE: '创建账号',
  REGISTER_PAGE_SUBTITLE: '三步快速完成，可随时保存并继续。',
  REGISTER_IDENTITY_TITLE: '账号类型',
  REGISTER_IDENTITY_INDIVIDUAL: '个人',
  REGISTER_IDENTITY_INDIVIDUAL_DESC: '个人使用。后续被邀请时可加入企业。',
  REGISTER_IDENTITY_BUSINESS: '企业',
  REGISTER_IDENTITY_BUSINESS_DESC: '面向诊所、机构和团队。发票开给企业，可邀请成员协作。',
  REGISTER_SUBTITLE_INDIVIDUAL: '创建个人 VMall 账号。',
  REGISTER_SUBTITLE_BUSINESS: '注册企业账号并成为所有者。',
  REGISTER_ALREADY_HAVE_ACCOUNT: '已有账号？',
  REGISTER_SIGN_IN: '前往登录',
  REGISTER_STEP_1: '企业信息',
  REGISTER_STEP_2: '主要联系人',
  REGISTER_STEP_3: '地址与确认',
  REGISTER_STEP_LABEL: '步骤 {{n}}',
  REGISTER_BACK: '上一步',
  REGISTER_CONTINUE: '继续',
  REGISTER_SAVE_LATER: '保存并稍后继续',
  REGISTER_SUBMIT: '提交注册',
  REGISTER_SUBMITTING: '提交中…',

  REGISTER_S1_HEADING: '企业信息',
  REGISTER_S1_SUBHEADING: '请填写您的执业信息，用于合规与开票。',
  REGISTER_TRADING_NAME: '企业/商家名称',
  REGISTER_LEGAL_ENTITY: '法人名称',
  REGISTER_ABN: 'ABN',
  REGISTER_ABN_HELP: '11 位澳大利亚商业号码',
  REGISTER_CLINIC_TYPE: '企业类型',
  REGISTER_AHPRA: 'AHPRA 注册号',
  REGISTER_TYPE_GP: '全科 / 家庭诊所',
  REGISTER_TYPE_SPECIALIST: '专科诊所',
  REGISTER_TYPE_DENTAL: '牙科诊所',
  REGISTER_TYPE_ALLIED: '辅助医疗',
  REGISTER_TYPE_OTHER: '其他',

  REGISTER_S2_HEADING: '主要联系人与登录信息',
  REGISTER_S2_SUBHEADING: '谁负责本企业的采购？',
  REGISTER_FIRST_NAME: '名',
  REGISTER_LAST_NAME: '姓',
  REGISTER_ROLE: '职位',
  REGISTER_PHONE: '电话',
  REGISTER_WORK_EMAIL: '工作邮箱',
  REGISTER_CONFIRM_EMAIL: '确认邮箱',
  REGISTER_PASSWORD: '密码',
  REGISTER_CONFIRM_PASSWORD: '确认密码',
  REGISTER_PASSWORD_HELP: '至少 12 位 · 含 1 个大写字母 · 1 个数字',
  REGISTER_PASSWORD_MISMATCH: '两次输入的密码不一致',
  REGISTER_EMAIL_MISMATCH: '两次输入的邮箱不一致',
  REGISTER_OWNER_NOTE: '该账号将作为所有者，您可在「设置 → 用户」中邀请采购员、成员与查看者。',

  REGISTER_S3_HEADING: '地址与确认',
  REGISTER_S3_SUBHEADING: '我们应将商品发往何处、向何处开票？您稍后可添加更多地址。',
  REGISTER_ADDRESS_LINE_1: '地址第一行',
  REGISTER_ADDRESS_LINE_2: '地址第二行（可选）',
  REGISTER_CITY: '城市 / 区',
  REGISTER_STATE: '州',
  REGISTER_POSTCODE: '邮编',
  REGISTER_REVIEW_HEADING: '信息确认',
  REGISTER_TERMS_AGREE: '我同意 VMall 服务条款，并确认我有权代表本企业注册。',

  REGISTER_SIDE_WHY_TITLE: '为什么需要这些信息',
  REGISTER_SIDE_WHY_S1: 'ABN 与 AHPRA 用于核实您为已注册的澳大利亚医疗机构，我们绝不会与供应商共享。',
  REGISTER_SIDE_WHY_S2: '所有者是订单、发票和账户决策的法律联系人，电话仅用于配送确认，不用于营销。',
  REGISTER_SIDE_WHY_S3: '默认收货与开票地址可让您当天即可下单，分支机构和仓储地址可稍后添加。',
  REGISTER_SIDE_SUMMARY_S1: '步骤 1 摘要',
  REGISTER_SIDE_SUMMARY_S2: '步骤 2 摘要',
  REGISTER_NEED_HELP: '注册需要帮助？',
  REGISTER_TALK_TO_ONBOARDING: '联系入驻支持 →',

  REGISTER_BUSINESS_NAME: '企业名称',
  REGISTER_FULL_NAME: '姓名',
  REGISTER_PHONE_OPTIONAL: '电话（可选）',
  REGISTER_PASSWORD_MIN_8: '至少 8 位',
  REGISTER_EMAIL_FROM_INVITATION: '已根据邀请预填',
  REGISTER_PASSWORD_TOO_SHORT: '密码至少 8 位',
  REGISTER_DEFAULT_ADDRESS_OPTIONAL: '默认地址（可选）',
  REGISTER_REQUIRED_FIELD: '此项为必填',
  REGISTER_INVALID_EMAIL: '请输入有效邮箱',
  REGISTER_INVALID_ABN: 'ABN 必须为 11 位数字',
  REGISTER_PASSWORD_TOO_WEAK: '密码须至少 12 位，并包含大写字母和数字',
  REGISTER_SUCCESS: '注册已提交，我们将尽快审核您的申请。',
  REGISTER_FAILED: '注册失败，请重试。',

  ACCOUNT_INACTIVE_TITLE: '账号未激活',
  ACCOUNT_INACTIVE_DESC: '该账号当前已停用或正在审核中，请联系平台支持。',

  FORBIDDEN_TITLE: '无访问权限',
  FORBIDDEN_DESC: '您没有访问此门户的权限。',
  GO_TO_LOGIN: '前往登录',

  ERROR_OCCURRED: '发生错误',
  RETRY: '重试',

  PRODUCT_LIST_TITLE: '商品列表',
  PRODUCT_DETAILS_TITLE: '商品详情',
  SEARCH_HERB_NAME: '搜索商品',
  FILTER_BY: '筛选',
  FILTER_BY_COUNT: '筛选 {{count}}',
  FILTER_RESET: '重置',
  HERB_ORIGIN_TYPE: '药材来源/类型',
  HERB_ORIGIN_ALL: '全部',
  HERB_ORIGIN_ROOT_RHIZOME: '根茎类',
  HERB_ORIGIN_LEAVES_FLOWERS: '叶花类',
  HERB_ORIGIN_FRUITS_SEEDS: '果实种子类',
  HERB_ORIGIN_BARK_RESIN: '皮树脂类',
  HERB_ORIGIN_ANIMAL: '动物类',
  HERB_ORIGIN_MINERAL: '矿物类',
  HERB_ORIGIN_WHOLE_HERB: '全草类',
  TAG_SPECIAL: '特价',
  TAG_FREQUENT: '常购',
  PRODUCT_INFO: '商品信息',
  INFO_SECTION_GENERAL: '基本信息',
  INFO_SECTION_INGREDIENTS: '成分',
  INFO_SECTION_DIRECTIONS: '用法用量',
  INFO_SECTION_WARNINGS: '注意事项',
  PRODUCT_USE_DISCLAIMER: '请仔细阅读标签并按说明使用。错误使用可能有害，请参阅下方健康与产品警示。',
  ADD: '加入',
  CART: '购物车',
  PRODUCT_ID_LABEL: '编号',

  PRODUCTS_TITLE: '商品',
  PRODUCTS_DESC: '浏览平台仓库已审核上架的可购商品。',
  PRODUCTS_EMPTY_TITLE: '暂无可用商品',
  PRODUCTS_EMPTY_DESC: '请更换关键字或清空过滤条件再试。',
  PRODUCT_NO_IMAGE: '暂无图片',
  PRODUCTS_CATEGORIES_HEADING: '分类',
  PRODUCTS_CATEGORY_ALL: '全部显示',
  PRODUCTS_CATEGORY_HERBS: '中药材',
  PRODUCTS_CATEGORY_MEDICINE: '药品',
  PRODUCTS_CATEGORY_SUPPLIES: '医疗用品',
  PRODUCTS_CATEGORY_CONSUMABLE: '耗材',
  PRODUCTS_CATEGORY_EQUIPMENT: '设备',
  PRODUCTS_CATEGORY_OTHER: '其他',
  PRODUCTS_CATEGORY_PHYSICAL: '商品',
  PRODUCTS_CATEGORY_VIRTUAL: '培训课程',
  PRODUCTS_FILTERS_TITLE: '筛选',
  PRODUCTS_FILTERS_RESET: '重置',
  PRODUCTS_FILTERS_GROUP_QUICK: '快速筛选',
  PRODUCTS_FILTERS_GROUP_BRAND: '品牌',
  PRODUCTS_FILTERS_GROUP_PRICE: '价格区间',
  PRODUCTS_FILTER_IN_STOCK: '仅看有货',
  PRODUCTS_FILTER_PREVIOUSLY_ORDERED: '曾经购买',
  PRODUCTS_FILTER_ON_PROMOTION: '促销中',
  PRODUCTS_FILTERS_BUTTON: '筛选',
  PRODUCTS_RESULTS_COUNT: '{{count}} 条结果 · 排序方式',
  PRODUCTS_SORT_MOST_ORDERED: '热销',
  PRODUCTS_SORT_NEWEST: '最新',
  PRODUCTS_SORT_PRICE_ASC: '价格 ↑',
  PRODUCTS_SORT_PRICE_DESC: '价格 ↓',
  PRODUCTS_PAGINATION_ROWS_PER_PAGE: '每页:',
  PRODUCTS_PAGINATION_DISPLAYED: '第 {{from}}–{{to}} 条 / 共 {{count}}',
  PRODUCTS_ACTIVE_FILTERS_LABEL: '已选:',
  PRODUCTS_CLEAR_ALL: '清空',
  PRODUCT_TAB_SPECS: '规格参数',
  PRODUCT_TAB_COMPLIANCE: '合规文档',
  PRODUCT_TAB_ORDER_HISTORY: '我的订购记录',
  PRODUCT_TAB_SUBSTITUTES: '同类替代',
  PRODUCT_DOC_DOWNLOAD: '下载 ↓',
  PRODUCT_HISTORY_LEAD: '近 6 个月你订购此商品 <0>{{count}} 次</0>',
  PRODUCT_NO_SUBSTITUTES: '暂无同类替代商品。',
  PRODUCT_BREADCRUMB_CATALOGUE: '商品目录',
  PRODUCT_TGA_REGISTERED: 'TGA 备案',
  PRODUCT_PRICE_PER_UNIT: '/单位',
  PRODUCT_PRICE_PLUS_GST: '+ GST {{amount}}',
  PRODUCT_QUANTITY_LABEL: '数量',
  PRODUCT_QUANTITY_RANGE: '起订 {{moq}} · 最多 {{max}}',
  PRODUCT_QUANTITY_RANGE_UNLIMITED: '起订 {{moq}} · 不限名额',
  PRODUCT_ADD_TO_CART_AMOUNT: '+ 加入购物车 · {{amount}}',
  PRODUCT_ADD_TO_CART: '加入购物车',
  PRODUCT_TOTAL_LABEL: '合计',
  PRODUCT_SUPPLIED_BY: '供应商',
  PRODUCT_NO_SPECS: '暂无规格信息。',
  PRODUCT_SPEC_CATEGORY: '类别',
  PRODUCT_SPEC_TYPE: '商品类型',
  PRODUCT_SPEC_SKU: 'SKU',
  PRODUCT_SPEC_SPECIFICATION: '规格',
  PRODUCT_SPEC_UNIT: '单位',
  SQUARE_LOADING: '正在加载安全支付表单…',
  SQUARE_LOAD_FAILED: '安全支付表单加载失败,请重试。',
  SQUARE_NOT_READY: '支付表单尚未就绪。',
  SQUARE_TOKENIZE_FAILED: '卡片信息校验失败,请检查后重试。',
  SQUARE_TEST_HINT: '沙盒测试卡:4111 1111 1111 1111 · 任意未来日期 · 任意 CVV。',
  ORDER_PAY_TITLE: '完成支付',
  ORDER_PAY_FAILED: '支付失败,请重试或更换卡片。',
  ORDER_PAID_BY_CARD: '已使用银行卡支付',
  ORDER_NOT_PAID_YET: '待支付',
  ORDER_INVOICE_DOWNLOAD_FAILED: '发票下载失败,请重试。',
  PRODUCT_NO_DOCS: '暂无相关文档。',
  PRODUCT_HISTORY_LEAD_AUTHED: '近 6 个月你订购此商品 {{count}} 次',
  SEARCH_PRODUCTS: '搜索商品',
  CATEGORY_ALL: '全部类别',
  STOCK_ALL: '全部库存状态',
  CATEGORY_MEDICINE: '药品',
  CATEGORY_CHINESE_HERB: '中药材',
  CATEGORY_MEDICAL_SUPPLY: '医用耗材',
  CATEGORY_CONSUMABLE: '一次性用品',
  CATEGORY_EQUIPMENT: '医疗设备',
  CATEGORY_OTHER: '其他',
  STOCK_IN_STOCK: '有货',
  STOCK_LOW_STOCK: '库存紧张',
  STOCK_OUT_OF_STOCK: '缺货',
  PRODUCT_ONLY_N_LEFT: '仅剩 {{count}} 件',
  PRODUCT_LAST_ORDERED_AGO: '上次下单 {{days}} 天前',
  PRODUCT_TYPE: '类型',
  PRODUCT_TYPE_ALL: '全部类型',
  PRODUCT_TYPE_PHYSICAL: '商品',
  PRODUCT_TYPE_VIRTUAL: '培训课程',
  VIRTUAL_FORMAT_ONLINE_COURSE: '在线课程',
  VIRTUAL_FORMAT_OFFLINE_COURSE: '线下课程',
  VIRTUAL_FORMAT_OTHER: '其他课程',
  VIRTUAL_SLOTS_UNIT: '席位',
  VIRTUAL_SLOTS_AVAILABLE: '剩 {{count}} 席',
  VIRTUAL_SLOTS_LEFT: '仅剩 {{count}} 席',
  VIRTUAL_SOLD_OUT: '已售罄',
  VIRTUAL_DELIST_IN_DAYS_one: '{{count}} 天后下架',
  VIRTUAL_DELIST_IN_DAYS_other: '{{count}} 天后下架',
  VIRTUAL_DELISTED: '已下架',
  VIRTUAL_OPEN_ENROLMENT: '持续招生',
  VIRTUAL_CAPACITY_LINE: '已售 {{sold}}/{{capacity}} · 剩 {{remaining}}',
  VIRTUAL_UNLIMITED_SLOTS: '名额不限',
  VIRTUAL_CAPACITY_LINE_UNLIMITED: '已售 {{sold}} · 名额不限',
  PHYSICAL_STOCK_LINE: '{{moq}} · 库存 {{count}}',
  PRICE_MIN_ORDER_SUFFIX: '（起订：{{count}} {{unit}}）',
  MOQ_LABEL: '起订 {{count}} 件',
  UNITS_COUNT: '{{count}} 件',
  ADDRESS_COUNTRY_FIXED: '一期仅支持澳大利亚境内配送。',
  PRODUCTS_FILTER_BRAND_CHIP: '品牌 · {{brand}}',
  PRODUCTS_FILTER_PRICE_CHIP: '${{min}}–${{max}}',
  PRODUCTS_FILTER_PRICE_MIN: '最低',
  PRODUCTS_FILTER_PRICE_MAX: '最高',
  PAGE_TITLE_DASHBOARD: '购物历史',
  PAGE_TITLE_CART: '购物车',
  PAGE_TITLE_LOGIN: '登录',
  PAGE_TITLE_REGISTER: '注册',
  PAGE_TITLE_CHECKOUT: '结算',
  PAGE_TITLE_404: '页面未找到',
  PAGE_TITLE_FORBIDDEN: '无访问权限',
  PAGE_TITLE_ACCOUNT_INACTIVE: '账户未激活',
  PAGE_TITLE_NOTIFICATIONS: '通知',
  PAGE_TITLE_PRODUCTS: '商品目录',
  PAGE_TITLE_PRODUCT_DETAIL: '商品详情',
  PAGE_TITLE_SUPPLIERS: '供应商',
  PAGE_TITLE_SUPPLIER_DETAIL: '供应商详情',
  PAGE_TITLE_ORDERS: '订单',
  PAGE_TITLE_ORDER_DETAIL: '订单详情',
  PAGE_TITLE_TRACK_ORDER: '查询订单',
  PAGE_TITLE_PAYMENTS: '付款记录',
  PAGE_TITLE_PAYMENT_DETAIL: '付款详情',
  PAGE_TITLE_PROFILE: '资料',
  PAGE_TITLE_ADDRESSES: '收货地址',
  PAGE_TITLE_BUSINESS_PROFILE: '账户信息',
  PAGE_TITLE_MEMBERS: '成员',
  PAGE_TITLE_INVITATIONS: '邀请',
  PAGE_TITLE_ONBOARDING: '欢迎使用',
  PAGE_TITLE_ACCEPT_INVITATION: '接受邀请',
  SIGN_IN_TO_BUY: '登录后购买',
  SUPPLIERS_TITLE: '供应商',
  SUPPLIERS_SUBTITLE: '通过 VMall 发货的品牌。',
  SUPPLIERS_EMPTY: '暂无公开供应商。',
  SUPPLIERS_HEADER_TITLE: '浏览供应商',
  SUPPLIERS_HEADER_LEAD: '所有商品均由 VMall 寄售仓发出。',
  SUPPLIERS_VERIFIED_BADGE_one: '{{count}} 家已认证供应商',
  SUPPLIERS_VERIFIED_BADGE_other: '{{count}} 家已认证供应商',
  SUPPLIERS_TGA_BADGE: '全部 TGA 备案',
  SUPPLIERS_SEARCH_PLACEHOLDER: '搜索供应商、品牌、类别…',
  SUPPLIERS_PREMIER_TITLE: '精选供应商',
  SUPPLIERS_PREMIER_LEAD: '优先发货的高评分合作伙伴。',
  SUPPLIERS_ALL_TITLE: '全部供应商',
  SUPPLIERS_ALL_LEAD_one: '{{count}} 家已认证供应商',
  SUPPLIERS_ALL_LEAD_other: '{{count}} 家已认证供应商',
  SUPPLIERS_VIEW_STORE: '进入店铺',
  SUPPLIERS_PREMIER_BADGE: '精选',
  SUPPLIERS_VERIFIED: '已认证',
  BUYER_NAV_SUPPLIERS: '供应商',
  SUPPLIER_BACK_TO_CATALOGUE: '返回商品目录',
  SUPPLIER_BACK_TO_DIRECTORY: '返回供应商列表',
  SUPPLIER_BRAND_LABEL: '供应商',
  SUPPLIER_PRODUCTS_COUNT: '商品数',
  SUPPLIER_PRODUCTS_TITLE: '{{name}} 的商品',
  SUPPLIER_NO_PRODUCTS: '该供应商暂无在售商品。',
  SUPPLIER_VERIFIED: '已认证',
  SUPPLIER_FOLLOW: '关注',
  SUPPLIER_FOLLOWING: '已关注',
  SUPPLIER_BROWSE_ALL_one: '浏览全部 {{count}}',
  SUPPLIER_BROWSE_ALL_other: '浏览全部 {{count}}',
  SUPPLIER_SEARCH_WITHIN: '在该供应商内搜索',
  SUPPLIER_FILTER_IN_STOCK: '仅看有货',
  SUPPLIER_NO_RESULTS: '没有符合条件的商品。',

  NOTIFICATIONS_TITLE: '通知',
  NOTIFICATIONS_SUBTITLE_one: '{{count}} 条未读',
  NOTIFICATIONS_SUBTITLE_other: '{{count}} 条未读',
  NOTIFICATIONS_FILTER_UNREAD: '未读',
  NOTIFICATIONS_EMPTY: '暂无未读通知',
  NOTIFICATIONS_TODAY: '今天',
  NOTIFICATIONS_YESTERDAY: '昨天',
  NOTIFICATIONS_EARLIER: '更早',

  NOTIFICATION_TITLE_BUSINESS_REGISTERED: '企业已创建',
  NOTIFICATION_BODY_BUSINESS_REGISTERED: '{{businessName}} 已注册成功。',
  NOTIFICATION_TITLE_BUSINESS_INVITATION_RECEIVED: '收到新的邀请',
  NOTIFICATION_BODY_BUSINESS_INVITATION_RECEIVED:
    '{{invitedBy}} 邀请你加入 {{businessName}}。',
  NOTIFICATION_TITLE_BUSINESS_INVITATION_ACCEPTED: '邀请已被接受',
  NOTIFICATION_BODY_BUSINESS_INVITATION_ACCEPTED:
    '{{invitedBy}} 已加入 {{businessName}}。',
  NOTIFICATION_TITLE_BUSINESS_MEMBER_REMOVED: '成员被移除',
  NOTIFICATION_BODY_BUSINESS_MEMBER_REMOVED: '{{businessName}} 有成员被移除。',
  NOTIFICATION_TITLE_BUSINESS_MEMBER_LEFT: '成员已离开',
  NOTIFICATION_BODY_BUSINESS_MEMBER_LEFT: '有成员离开了 {{businessName}}。',

  NOTIFICATION_TITLE_ORDER_CREATED: '订单已创建',
  NOTIFICATION_BODY_ORDER_CREATED: '订单 {{orderNumber}} 等待付款。',
  NOTIFICATION_TITLE_ORDER_PAID: '已收到付款',
  NOTIFICATION_BODY_ORDER_PAID: '订单 {{orderNumber}} 已付款。',
  NOTIFICATION_TITLE_ORDER_DISPATCHED: '订单已发货',
  NOTIFICATION_BODY_ORDER_DISPATCHED:
    '订单 {{orderNumber}} 通过 {{carrier}} 发出（{{trackingNumber}}）。',
  NOTIFICATION_TITLE_ORDER_CANCELLED: '订单已取消',
  NOTIFICATION_BODY_ORDER_CANCELLED: '订单 {{orderNumber}} 已取消。',
  NOTIFICATION_TITLE_ORDER_EXPIRED: '订单已过期',
  NOTIFICATION_BODY_ORDER_EXPIRED: '订单 {{orderNumber}} 因未及时付款已过期。',
  NOTIFICATION_TITLE_ORDER_PAYMENT_FAILED: '付款失败',
  NOTIFICATION_BODY_ORDER_PAYMENT_FAILED:
    '订单 {{orderNumber}} 付款失败。{{reason}}',

  NOTIFICATION_TITLE_VIRTUAL_PRODUCT_DELIVERED: '访问凭证已送达',
  NOTIFICATION_BODY_VIRTUAL_PRODUCT_DELIVERED:
    '{{productName}} 的访问凭证已发送到你的邮箱。',
  NOTIFICATION_TITLE_VIRTUAL_PRODUCT_DELIVERY_FAILED: '送达失败 · 重试中',
  NOTIFICATION_BODY_VIRTUAL_PRODUCT_DELIVERY_FAILED:
    '未能送达 {{productName}}。{{reason}}',
  NOTIFICATION_TITLE_VIRTUAL_PRODUCT_AUTO_DELISTED: '培训课程已下架',
  NOTIFICATION_BODY_VIRTUAL_PRODUCT_AUTO_DELISTED:
    '{{productName}} 已停止销售。',

  NOTIFICATION_TITLE_GUEST_ORDER_CREATED: '游客订单已创建',
  NOTIFICATION_BODY_GUEST_ORDER_CREATED: '游客订单 {{orderNumber}} 已创建。',
  NOTIFICATION_TITLE_GUEST_ORDER_PAID: '游客订单已付款',
  NOTIFICATION_BODY_GUEST_ORDER_PAID: '游客订单 {{orderNumber}} 已付款。',
  NOTIFICATION_TITLE_GUEST_ORDER_DISPATCHED: '游客订单已发货',
  NOTIFICATION_BODY_GUEST_ORDER_DISPATCHED:
    '游客订单 {{orderNumber}} 已发出。',
  ADD_TO_CART: '加入购物车',
  BUY_NOW: '立即购买',
  PER_UNIT: '每 {{unit}}',
  MOQ: '最小起订量',
  MOQ_X: '起订量 {{count}}',
  GST_RATE: 'GST 税率',
  AVAILABLE_STOCK: '可用库存',
  BACK_TO_PRODUCTS: '返回商品列表',
  NO_IMAGE: '暂无图片',

  CART_TITLE: '购物车',
  CART_DESC: '结算前请检查并调整商品。',
  CART_EMPTY_TITLE: '购物车为空',
  CART_EMPTY_DESC: '添加商品后即可创建订单。',
  CART_ADDED: '已加入购物车：{{name}}',
  CART_IN_CART_QTY_one: '已加入购物车 {{count}} 件',
  CART_IN_CART_QTY_other: '已加入购物车 {{count}} 件',
  CART_ADD_FAILED: '加入购物车失败',
  CART_UPDATE_FAILED: '购物车更新失败',
  CART_UPDATE: '更新购物车',
  CART_UPDATE_SHORT: '更新',
  ADD_TO_CART_SHORT: '加购',
  BUY_NOW_SHORT: '购买',
  GO_TO_CART: '去购物车',
  IN_CART_GO_TO_CART: '已加入 {{count}} 件 · 去购物车 →',
  CART_HAS_CONFLICTS: '购物车存在问题，请处理后再结算',
  CART_CONFLICTS_TITLE: '购物车问题',
  CART_STOCK_CLAMP_TITLE: '部分商品数量已根据可用库存自动调整。',
  CART_CHECKOUT_HINT: '下一步将填写收货地址与支付信息',
  CART_DISMISS: '关闭',
  CART_CLAMP_SUMMARY: '{{clamped}} 项已按可用库存调整数量，{{removed}} 项已下架。请在结算前确认。',
  CART_SAVE_AS_TEMPLATE: '保存为模板',
  CART_SAVE_AS_TEMPLATE_TIP: '即将推出',
  CART_CONTINUE_TO_CHECKOUT: '继续结算',
  CART_SUBTOTAL_WITH_COUNT: '小计（共 {{count}} 件）',
  CART_FREIGHT_ESTIMATE: '运费（预估）',
  MIN_PHYSICAL_ORDER_NOTICE: '商品小计需满 {{amount}} 才能结算。',
  FREE_SHIPPING_OVER_THRESHOLD: '商品订单满 {{amount}} 免运费。',
  CART_DISCOUNT: '优惠',
  CART_TOTAL_WITH_GST: '合计（含 GST）',
  CART_TRUST_TITLE: '绝不超卖。',
  CART_TRUST_BODY: '结算时会重新核对库存，如有变化将在付款前明确告知您。',
  RECHECK_STOCK: '重新检查库存',
  PRODUCT: '商品',
  QUANTITY: '数量',
  UNIT_PRICE: '单价',
  NOTIFY_ME: '到货通知',
  CART_ROW_IN_STOCK: '库存 {{count}}',
  CART_ROW_REDUCED: '已从 {{from}} 调整至 {{max}}（库存不足）',
  CART_ROW_NO_LONGER_STOCK: '已无库存',
  ITEMS_COUNT: '{{count}} 件商品',
  SYDNEY_WAREHOUSE: '悉尼仓',
  PROCEED_TO_CHECKOUT: '前往结算',
  VALIDATING: '校验中…',
  BROWSE_PRODUCTS: '浏览商品',
  CONTINUE_SHOPPING: '继续购物',

  CHECKOUT_TITLE: '结算',
  CHECKOUT_DESC: '确认收货地址并提交订单。',
  CHECKOUT_STEP_LABEL: '步骤 {{n}}',
  CHECKOUT_STEP_1_TITLE: '订单确认',
  CHECKOUT_STEP_1_SUMMARY: '已确认 {{count}} 件商品 · 库存已核对',
  CHECKOUT_STEP_2_TITLE: '收货与运费',
  CHECKOUT_STEP_2_TITLE_VIRTUAL: '接收邮箱',
  DELIVERY_EMAIL_LABEL: '培训课程接收邮箱',
  DELIVERY_EMAIL_HELP: '支付完成后,培训课程将发送到此邮箱。',
  DELIVERY_EMAIL_INVALID: '请输入有效的邮箱地址。',
  ORDER_DELIVERY_EMAIL: '接收邮箱',
  ORDER_DELIVERY_EMAIL_HELP: '培训课程已发送到此邮箱。',
  CHECKOUT_STEP_3_TITLE: '请选择支付方式',
  CHECKOUT_STEP_OF: '第 {{n}} 步 / 共 {{total}} 步',
  CHECKOUT_STEP_ACCOUNT_TITLE: '填写信息',
  CHECKOUT_STEP_ADDRESS_TITLE: '收货与账单地址',
  CHECKOUT_STEP_CONFIRM_TITLE: '确认订单',
  CHECKOUT_CONFIRM_ITEMS: '本次订单商品',
  CHECKOUT_CREATE_ACCOUNT: '创建账号',
  CHECKOUT_CREATING_ACCOUNT: '创建中…',
  CHECKOUT_CREATE_ACCOUNT_HINT: '请先创建账号以继续，创建成功后将自动登录。',
  CHECKOUT_BACK: '上一步',
  CHECKOUT_CONTINUE: '继续',
  CHECKOUT_ACCOUNT_CREATED: '账号已创建，已自动登录。',
  CHECKOUT_EDIT: '修改',
  CHECKOUT_DEFAULT_ADDRESS: '默认',
  CHECKOUT_FREIGHT_OPTION: '标准运费',
  CHECKOUT_FREIGHT_EXPRESS: '加急运费',
  CHECKOUT_FREIGHT_PROVIDER: 'StarTrack',
  CHECKOUT_FREIGHT_ETA: '预计到达 {{date}}',
  CHECKOUT_FREIGHT_NOTE: '签收',
  CHECKOUT_BILLING_ADDRESS: '账单地址',
  CHECKOUT_BILLING_SAME: '与收货地址相同',
  CHECKOUT_BILLING_ENTER: '请输入账单地址',
  CHECKOUT_BILLING_CHANGE: '更改',
  CHECKOUT_DONE_EDITING: '完成',
  CHECKOUT_PAYMENT_METHOD: '支付方式',
  CHECKOUT_ADD_CARD: '添加新卡',
  CHECKOUT_CARDHOLDER: '持卡人姓名',
  CHECKOUT_CARD_NUMBER: '卡号',
  CHECKOUT_EXPIRY: '有效期',
  PRICE_CONTACT_PLATFORM: '请联系平台',
  CHECKOUT_CVC: 'CVC',
  CHECKOUT_SAVE_CARD: '保存此卡以备下次使用',
  CHECKOUT_PAY_SECURELY: '安全支付 {{amount}}',
  CHECKOUT_TERMS_BLURB: '支付即表示您同意 VMall 订单条款。库存自此步骤起将为您保留 8 分钟。',
  CHECKOUT_PCI_TITLE: '符合 PCI 规范。',
  CHECKOUT_PCI_BODY: '卡片信息通过 Stripe 令牌化处理，不会存储在 VMall 服务器。',
  CHECKOUT_VISA: 'VISA',
  CHECKOUT_REMOVE_CARD: '移除此卡',
  CHECKOUT_MASTERCARD: 'MASTERCARD',
  CHECKOUT_CARD_EXPIRES: '有效期至 {{date}}',
  SHIPPING_ADDRESS: '收货地址',
  SHIPPING_ADDRESS_INCOMPLETE: '收货地址信息不完整',
  ORDER_ITEMS: '订单商品',
  ORDER_SUMMARY: '订单汇总',
  SUBTOTAL: '小计',
  GST: 'GST 税额',
  TOTAL: '合计',
  PLACE_ORDER: '提交订单',
  ORDER_TOTAL: '总计',
  PLACING_ORDER: '提交中…',
  BACK_TO_CART: '返回购物车',
  ORDER_CREATED: '支付成功，订单已创建',
  ORDER_CREATE_FAILED: '订单创建失败',

  CONTACT_NAME: '联系人',
  CONTACT_PHONE: '联系电话',
  ADDRESS_LINE1: '地址第 1 行',
  ADDRESS_LINE2: '地址第 2 行',
  SUBURB: '区 / 镇',
  STATE: '州',
  POSTCODE: '邮编',
  COUNTRY: '国家',

  ORDERS_TITLE: '全部订单',
  ORDERS_PAGE_SUBTITLE: '你的业务与用户 · 最近 12 个月',
  ORDERS_TOTAL_COUNT: '共 {{count}} 条',
  ORDERS_EXPORT_CSV: '导出 CSV',
  ORDERS_NEW_ORDER: '去购物',
  ORDERS_DATE_RANGE_PLACEHOLDER: '4 月 1 日 — 5 月 6 日',
  ORDERS_PLACED_BY: '下单人：全部',
  ORDERS_SHIP_TO: '收货地址：全部',
  ORDERS_SAVED_VIEWS: '快捷视图：',
  ORDERS_VIEW_OPEN: '进行中订单',
  ORDERS_VIEW_Q2_REORDERS: 'Q2 复购',
  ORDERS_TAB_ALL: '全部',
  ORDER_REORDER: '再次下单',
  ORDER_BUY_AGAIN: '加入购物车',
  ORDER_AND_MORE_ITEMS: '等 {{count}} 件商品',
  ORDER_PLACED_AT_LABEL: '下单时间',
  ORDER_CARRIER_LABEL: '物流',
  ORDER_SHIP_TO_LABEL: '收货地区',
  ORDER_VIEW_LOGISTICS: '查看物流',
  ORDER_MORE: '更多',
  ORDER_PAID_AMOUNT: '实付款',
  ORDER_SHOP_FALLBACK: 'Vmall 商城',
  ORDER_DOWNLOAD_INVOICE: '下载发票',
  ORDER_INVOICE_COMING_SOON: '发票下载即将推出',
  ORDER_REORDER_DONE: '已将 {{count}} 件商品加入购物车',
  ORDER_SHIP_TO_COL: '收货地址',
  ORDER_PLACED_BY_COL: '下单人',
  ORDER_DATE_COL: '日期',
  ORDER_GUEST: '访客',

  ORDER_HERO_NUMBER: '订单号',
  ORDER_HERO_PLACED: '下单时间',
  ORDER_HERO_STATUS: '状态',
  ORDER_PRINT: '打印',
  ORDER_INVOICE: '发票',
  ORDER_TRACKING_TIMELINE: '物流轨迹',
  ORDER_CARRIER: '物流公司',
  ORDER_TRACKING_NUMBER: '运单号',
  ORDER_ITEMS_LINES: '{{lines}} 项 · 共 {{boxes}} 件',
  ORDER_BILL_TO: '账单信息',
  ORDER_BILLING_SAME_AS_SHIPPING: '与收货地址相同',
  ORDER_SHIP_TO: '收货信息',
  ORDER_SHIPPING_METHOD: '配送方式',
  ORDER_SHIPPING_METHOD_LABEL: '配送方式',
  ORDER_NOTES: '备注',
  ORDER_NOTES_LABEL: '备注',
  ORDER_PAYMENT: '付款',
  ORDER_SUMMARY_LABEL: '金额合计',
  ORDER_PAID_BADGE: '已支付',
  ORDER_FREIGHT: '运费',
  ORDER_PO_NUMBER: 'PO 号',
  ORDER_ABN_LABEL: 'ABN',
  ORDER_PAID_AT: '扣款于 {{time}}',
  ORDER_ETA_PREFIX: '预计',

  ORDER_TRACK_PLACED: '订单已提交',
  ORDER_TRACK_PROCESSING: '正在处理',
  ORDER_TRACK_PACKED: '已打包',
  ORDER_TRACK_TRANSIT: '运输中',
  ORDER_TRACK_OUT_FOR_DELIVERY: '派送中',
  ORDER_TRACK_DELIVERED: '已送达',
  ORDER_TRACK_PENDING: '待处理',
  ORDER_TRACK_EXPECTED: '预计 {{date}}',
  ORDERS_DESC: '订单历史。',
  ORDERS_EMPTY_TITLE: '暂无订单',
  ORDERS_EMPTY_DESC: '从商品页发起第一单。',
  BACK_TO_ORDERS: '返回订单列表',
  ORDER_ID: '订单号',
  CREATED_AT: '创建时间',
  ITEMS: '商品数',
  STATUS: '状态',
  ORDER_TIMELINE: '订单进程',
  TRACKING: '物流',

  ORDER_PENDING_PAYMENT: '待支付',
  ORDER_PAID: '已支付',
  ORDER_PROCESSING: '处理中',
  ORDER_DISPATCHED: '已发货',
  ORDER_RECEIVED: '已收货',
  ORDER_COMPLETED: '已完成',
  ORDER_CANCELLED: '已取消',
  ORDER_PAYMENT_FAILED: '支付失败',
  ORDER_EXPIRED: '已过期',

  PAYMENT_COUNTDOWN: '库存预留还剩 {{time}}，请尽快完成支付。',
  PAYMENT_SUCCESS: '支付成功',
  PAYMENT_FAILED_NOTI: '支付失败，请重试或联系客服。',
  PAY_NOW: '立即支付',
  PAYING: '支付中…',
  CANCELLING: '取消中…',
  MOCK_PAYMENT_HINT: '开发环境 — 请选择支付结果：',
  SIMULATE_PAY_SUCCESS: '模拟支付成功',
  SIMULATE_PAY_FAILURE: '模拟支付失败',
  CANCEL_ORDER: '取消订单',
  CANCEL_ORDER_CONFIRM_TITLE: '确认取消该订单？',
  CANCEL_ORDER_CONFIRM_DESC: '预留库存将被释放，操作不可恢复。',
  ORDER_CANCELLED_NOTI: '订单已取消',
  ORDER_CANCEL_FAILED: '取消订单失败',

  SEARCH_ORDERS: '按订单号搜索',
  ORDER_STATUS_ALL: '全部状态',

  PAYMENTS_TITLE: '支付记录',
  PAYMENTS_DESC: '支付记录。',
  PAYMENTS_EMPTY_TITLE: '暂无支付记录',
  PAYMENTS_EMPTY_DESC: '完成支付后即可看到记录。',
  SEARCH_PAYMENTS: '按支付或订单号搜索',
  PAYMENT_STATUS_ALL: '全部状态',
  PAYMENT_STATUS_PAID: '已支付',
  PAYMENT_STATUS_PENDING: '待处理',
  PAYMENT_STATUS_FAILED: '支付失败',
  PAYMENT_STATUS_REFUNDED: '已退款',
  PAYMENT_STATUS_CANCELLED: '已取消',
  PAYMENT_ID: '支付编号',
  AMOUNT: '金额',
  PAYMENT_METHOD: '支付方式',
  PAID_AT: '支付时间',
  BACK_TO_PAYMENTS: '返回支付记录',
  DOWNLOAD_INVOICE: '下载发票',
  DOWNLOADING: '下载中…',
  INVOICE_DOWNLOAD_FAILED: '下载发票失败',
  INVOICE_MOCK_HINT: 'Mock 发票 — 将生成纯文本文件。',

  CONFIRM_RECEIVED: '确认收货',
  CONFIRM_RECEIVED_TITLE: '确认已收到货？',
  CONFIRM_RECEIVED_DESC: '将订单标记为已完成。',
  ORDER_RECEIVED_NOTI: '订单已确认收货',
  ORDER_RECEIVED_FAILED: '确认收货失败',

  REORDER: '重新加入购物车',
  REORDERING: '加入购物车…',
  REORDER_SUCCESS: '已加入购物车 {{count}} 个商品',
  REORDER_PARTIAL: '已加入 {{added}} 个商品；{{skipped}} 个因库存变化被跳过',
  REORDER_ALL_SKIPPED: '所有商品当前都无可用库存，无法再下单',
  REORDER_FAILED: '再下单失败',

  DEV_TOOLS_HINT: '开发工具（仅 Mock 模式）— 仓库门户尚未上线：',
  DEV_SIMULATE_DISPATCH: '模拟发货',
  DEV_DISPATCHING: '发货中…',
  DEV_DISPATCH_DONE: '订单已标记为已发货（mock）',

  PROFILE_TITLE: '账户信息',
  PROFILE_DESC: '账号与企业信息。',
  USER_INFO: '用户',
  NAME: '姓名',
  ROLE: '角色',
  CLINIC_INFO: '企业',
  CLINIC_NAME: '企业名称',
  ABN: 'ABN',
  CLINIC_EMAIL: '联系邮箱',
  CLINIC_PHONE: '联系电话',
  BILLING_ADDRESS: '账单地址',
  NOT_SET: '未设置',
  EDIT_ADDRESSES: '编辑地址',
  CLINIC_STATUS_ACTIVE: '已激活',
  CLINIC_STATUS_PENDING_REVIEW: '审核中',
  CLINIC_STATUS_DISABLED: '已停用',
  CLINIC_STATUS_REJECTED: '已拒绝',

  ADDRESSES_DESC: '维护账单与收货地址，将用于后续订单。',
  BACK_TO_PROFILE: '返回企业资料',
  COPY_FROM_BILLING: '复制账单地址',
  BILLING_ADDRESS_INCOMPLETE: '账单地址信息不完整',
  SAVE_ADDRESSES: '保存地址',
  ADDRESSES_SAVED: '地址已保存',
  ADDRESSES_SAVE_FAILED: '保存地址失败',

  BUYER_NAV_PRODUCTS: '商品',
  BUYER_NAV_CATALOGUE: '商品目录',
  BUYER_NAV_CART: '购物车',
  BUYER_NAV_ORDERS: '订单',
  BUYER_NAV_PAYMENTS: '支付记录',
  BUYER_NAV_PROFILE: '账户信息',
  BUYER_NAV_PROFILE_PERSONAL: '个人资料',
  BUYER_NAV_ADDRESSES: '收货地址',
  BUYER_NAV_NOTIFICATIONS: '通知',
  BUYER_NAV_DASHBOARD: '购物历史',
  BUYER_NAV_TRACK_ORDER: '订单查询',
  BUYER_NAV_GROUP_WORKSPACE: '工作区',
  BUYER_NAV_GROUP_RECORDS: '记录',
  BUYER_NAV_GROUP_ACCOUNT: '账户',
  SIDEBAR_NEED_HELP: '需要帮助？',
  SEARCH_PLACEHOLDER_TOPBAR: '搜索 SKU、订单、发票',
  FILTERS: '筛选',
  FILTERS_APPLY: '应用',

  DASHBOARD_GREETING: '早上好，{{name}} 👋',
  DASHBOARD_SUBTITLE: '这是 {{clinic}} 的最新动态。',
  DASHBOARD_EXPORT: '导出报表',
  DASHBOARD_NEW_ORDER: '去购物',
  DASHBOARD_OPEN_ORDERS: '进行中订单',
  DASHBOARD_IN_TRANSIT: '运输中',
  DASHBOARD_MONTH_SPEND: '本月支出',
  DASHBOARD_STOCK_ALERTS: '库存提醒',
  DASHBOARD_QUICK_REORDER: '快速补货',
  DASHBOARD_QUICK_REORDER_HINT: '近 90 天最常下单的商品',
  DASHBOARD_VIEW_ALL: '查看全部 →',
  DASHBOARD_RECENT_ORDERS: '最近订单',
  DASHBOARD_ALL_ORDERS: '所有订单 →',
  DASHBOARD_STOCK_REMINDERS: '库存提醒',
  DASHBOARD_RECENTLY_RESTOCKED: '最近补货',
  DASHBOARD_NOTIFICATIONS: '通知',
  DASHBOARD_MARK_ALL_READ: '全部标为已读',
  DASHBOARD_REVIEW_NOW: '立即查看 →',
  DASHBOARD_SINCE_YESTERDAY: '较昨日 +1',
  DASHBOARD_VS_LAST_MONTH: '同比上月 +12%',
  DASHBOARD_ETA: '预计',
  DASHBOARD_REORDER_X: '补货 × {{count}}',
  DASHBOARD_NOTIFY_ME: '到货通知',
  DASHBOARD_LOW: '偏低',
  DASHBOARD_OOS: '缺货',
  DASHBOARD_LAST_ORD: '上次下单 {{days}} 天前',
  DASHBOARD_BACK_SINCE: '{{when}} 起到货',
  DASHBOARD_BACK_TODAY: '今日到货',
  DASHBOARD_GREETING_DR_NAME: '{{name}}',
  DASHBOARD_GREETING_FALLBACK: '你好',
  DASHBOARD_CLINIC_FALLBACK: '您的企业',
  DASHBOARD_ETA_DATE_PLACEHOLDER: '5 月 6 日（周三）',
  DASHBOARD_ORDER_STATUS_IN_TRANSIT: '运输中',
  DASHBOARD_ORDER_STATUS_PACKED: '已打包',
  DASHBOARD_ORDER_STATUS_PROCESSING: '处理中',
  DASHBOARD_ORDER_STATUS_DELIVERED: '已送达',
  DASHBOARD_DAY_MON: '周一',
  DASHBOARD_DAY_TUE: '周二',
  DASHBOARD_WHEN_MIN_one: '{{count}} 分钟前',
  DASHBOARD_WHEN_MIN_other: '{{count}} 分钟前',
  DASHBOARD_WHEN_HOUR_one: '{{count}} 小时前',
  DASHBOARD_WHEN_HOUR_other: '{{count}} 小时前',
  DASHBOARD_NOTIF_TITLE_ORDER_SHIPPED: '订单已发货',
  DASHBOARD_NOTIF_DESC_ORDER_SHIPPED: '{{orderId}} · {{cartons}} 箱',
  DASHBOARD_NOTIF_TITLE_PAYMENT_RECEIVED: '收到付款',
  DASHBOARD_NOTIF_DESC_PAYMENT_RECEIVED: '{{orderId}} · {{amount}}',
  DASHBOARD_NOTIF_TITLE_STOCK_LOW: '库存偏低',
  DASHBOARD_NOTIF_DESC_STOCK_LOW: '{{product}} · 剩 {{units}}',
  DASHBOARD_NO_RECENT_ORDERS: '暂无订单。前往商品目录下你的第一个订单。',
  NOTIFICATIONS_PAGE_TITLE: '通知中心',
  NOTIFICATIONS_UNREAD_SUMMARY: '{{unread}} 条未读 · 近 30 天 {{total}} 条',
  NOTIFICATIONS_PREFERENCES: '通知设置',
  NOTIFICATIONS_FILTER_ALL: '全部',
  NOTIFICATIONS_FILTER_ORDERS: '订单',
  NOTIFICATIONS_FILTER_STOCK: '库存',
  NOTIFICATIONS_FILTER_PAYMENTS: '支付',
  NOTIFICATIONS_FILTER_SYSTEM: '系统',
  NOTIFICATIONS_FILTER_CRITICAL: '紧急',
  NOTIFICATIONS_QUIET_HOURS: '勿扰时段已开启',
  NOTIFICATIONS_QUIET_HOURS_DESC: '18:00 — 08:00 暂停邮件摘要，紧急提醒仍会送达。',
  NOTIFICATIONS_MARK_ALL_READ: '全部标为已读',
  NOTIFICATIONS_REFRESH: '刷新',
  NOTIFICATIONS_VIEW_LINK: '查看 →',
  NOTIFICATIONS_CRITICAL_BADGE: '紧急 · 需要处理',
  NOTIFICATIONS_GROUP_TODAY: '今天 · 5 月 6 日',
  NOTIFICATIONS_GROUP_YESTERDAY: '昨天 · 5 月 5 日',
  NOTIFICATIONS_GROUP_EARLIER: '本周早些时候',
  NOTIFICATIONS_CRITICAL_ALERT_TITLE: '⚠ {{count}} 条紧急提醒待处理',
  NOTIFICATIONS_REVIEW_RECALL: '查看召回 →',
  NOTIFICATIONS_FILTER_PANEL_TITLE: '筛选',
  NOTIFICATIONS_STATUS_LABEL: '状态',
  NOTIFICATIONS_PRIORITY_LABEL: '优先级',
  NOTIFICATIONS_STATUS_ALL: '全部',
  NOTIFICATIONS_STATUS_UNREAD: '仅未读',
  NOTIFICATIONS_STATUS_READ: '仅已读',
  NOTIFICATIONS_PRIORITY_CRITICAL: '紧急',
  NOTIFICATIONS_PRIORITY_HIGH: '高',
  NOTIFICATIONS_PRIORITY_MEDIUM: '中',
  NOTIFICATIONS_PRIORITY_LOW: '低',

  GUEST_MODE: '游客浏览',
  GUEST_MODE_BANNER: '游客下单',
  GUEST_CONTACT_INCOMPLETE: '请填写联系方式',
  GUEST_EMAIL_INVALID: '请输入有效的邮箱地址',
  GUEST_EMAIL_HELP: '用于发送收据并稍后查询订单。',
  CONTACT_DETAILS: '联系方式',
  FIRST_NAME: '名字',
  LAST_NAME: '姓氏',
  PHONE: '电话',
  CLINIC_NAME_OPTIONAL: '企业名称（选填）',
  CREATE_ACCOUNT_WITH_EMAIL: '使用此邮箱创建账号',
  PASSWORD_MIN_8: '至少 8 个字符。',
  PASSWORD_TOO_SHORT: '密码至少需要 8 个字符',

  ORDER_LOOKUP_TITLE: '订单查询',
  ORDER_LOOKUP_RESULT_TITLE: '订单详情',
  ORDER_LOOKUP_DESC: '请输入下单确认邮件中的订单编号以及下单时使用的邮箱。',
  ORDER_LOOKUP_FAILED: '未找到订单，请检查订单号和邮箱后再试。',
  ORDER_LOOKUP_MISSING_EMAIL: '查看订单需要邮箱地址。',
  ORDER_ID_PLACEHOLDER: '例如 o-xxxxxxxx',
  LOOK_UP_ORDER: '查询订单',
  LOADING: '加载中…',

  CONFIRMATION_EMAIL_SENT: '确认订单邮件已发送至 {{email}}。',
  RESEND_EMAIL: '重新发送邮件',
  RESEND_IN_SECONDS: '{{seconds}} 秒后可重新发送',
  SENDING: '发送中…',
  RECEIPT_RESENT: '收据邮件已发送',
  RECEIPT_RESEND_FAILED: '无法重新发送收据邮件',

  // V2.2 Buyer Portal 命名（追加；同名的 CLINIC_* → BUYER_* 键已在上方）
  BUYER_PORTAL_TITLE: '采购门户',
  BUYER_NAV_GROUP_BUSINESS: '企业',
  BUYER_NAV_BUSINESS: '我的企业',
  BUYER_NAV_BUSINESS_MEMBERS: '成员',
  BUYER_NAV_BUSINESS_INVITATIONS: '邀请',

  BUYER_IDENTITY_TITLE: '采购身份',
  BUYER_IDENTITY_OWNER: '所有者',
  BUYER_IDENTITY_MEMBER: '成员',
  BUYER_IDENTITY_PERSONAL: '个人账户',
  BUYER_IDENTITY_MANAGE_BUSINESS: '管理企业',
  BUYER_IDENTITY_INDIVIDUAL_HINT:
    '您正以个人身份使用 VMall。可以创建或加入一个 企业 来管理团队订单。',
  BUYER_IDENTITY_CREATE_OR_JOIN: '创建或加入企业',

  DEFAULT_BILLING_ADDRESS: '默认账单地址',
  DEFAULT_SHIPPING_ADDRESS: '默认收货地址',

  ONBOARDING_TITLE: '欢迎使用 VMall',
  ONBOARDING_SUBTITLE: '请选择您的使用方式。',
  ONBOARDING_PERSONAL_TITLE: '继续使用个人账户',
  ONBOARDING_PERSONAL_BODY: '以个人身份下单,您稍后可随时创建或加入 企业。',
  ONBOARDING_PERSONAL_CTA: '继续',
  ONBOARDING_BUSINESS_TITLE: '设置我的 企业',
  ONBOARDING_BUSINESS_BODY: '统一管理团队订单、成员与 企业 发票。',
  ONBOARDING_BUSINESS_CTA: '创建 企业',
  BUSINESS_CREATE_TITLE: '创建 企业',
  BUSINESS_CREATE_DESC: '先为您的 企业 取个名称即可开始。ABN、地址等信息可稍后补充。',
  BUSINESS_CREATE_NAME_LABEL: '企业 名称',
  BUSINESS_CREATE_NAME_PLACEHOLDER: '例如：江畔医疗诊所',
  BUSINESS_CREATE_SUBMIT: '创建 企业',
  BUSINESS_CREATING: '创建中…',
  BUSINESS_CREATE_SUCCESS: '{{name}} 已创建，您现在是所有者。',
  BUSINESS_CREATE_FAILED: '创建 企业 失败，请重试。',
  ONBOARDING_INVITATION_TITLE: '我有邀请码',
  ONBOARDING_INVITATION_BODY: '粘贴 企业 所有者发送给您的邀请码。',
  ONBOARDING_INVITATION_TOKEN_LABEL: '邀请码',
  ONBOARDING_INVITATION_CTA: '接受邀请',
  ONBOARDING_ACCEPTING: '接受中…',
  ONBOARDING_FOOTER_HINT: '您可以随时在个人资料里在个人 / 企业 之间切换。',

  INVITATION_PREVIEW_LABEL: 'BUSINESS 邀请',
  INVITATION_INVITE_HEADING: '{{name}} 邀请您加入他们在 VMall 的 企业。',
  INVITATION_INVITED_EMAIL_LINE: '邀请已发送至 {{email}}',
  INVITATION_EXPIRES_LINE: '邀请将于 {{date}} 过期。',
  INVITATION_LOGIN_REQUIRED: '登录现有账号，或新建一个账号以加入此企业。',
  INVITATION_SIGN_IN_AND_JOIN: '登录并加入',
  INVITATION_REGISTER_AND_JOIN: '注册新账号并加入',
  INVITATION_ACCEPT_CTA: '接受邀请',
  INVITATION_ACCEPTED: '您已加入 {{name}}。',
  INVITATION_ACCEPT_FAILED: '无法接受邀请。',

  BUSINESS_TITLE: '企业 资料',
  BUSINESS_IDENTITY: '企业 身份',
  BUSINESS_NAME: '企业 名称',
  BUSINESS_INDUSTRY: '行业',
  BUSINESS_CONTACT_PERSON: '主要联系人',
  BUSINESS_PHONE: '企业 电话',
  BUSINESS_EMAIL: '企业 邮箱',
  BUSINESS_EDIT: '编辑',
  BUSINESS_MEMBERS: '成员',
  BUSINESS_INVITATIONS: '邀请管理',
  BUSINESS_NOT_MEMBER_TITLE: '您当前不在任何 企业 中',
  BUSINESS_NOT_MEMBER_DESC: '创建或接受邀请加入一个 企业 即可统一管理团队订单。',
  BUSINESS_SAVED: '企业 资料已保存。',
  BUSINESS_SAVE_FAILED: '企业 资料保存失败。',
  BUSINESS_FORM_INCOMPLETE: '请填写所有必填项。',
  BUSINESS_STATUS_ACTIVE: '已生效',
  BUSINESS_STATUS_PENDING_REVIEW: '审核中',
  BUSINESS_STATUS_DISABLED: '已停用',
  BUSINESS_STATUS_REJECTED: '已驳回',
  BUSINESS_ADDRESS_MISSING_BANNER: '账单地址或收货地址还未填写，请补充完整以便后续下单与发货。',
  BUSINESS_ADDRESS_MISSING_ACTION: '前往补全',
  BUSINESS_LEFT: '您已退出该 企业。',
  BUSINESS_LEAVE_FAILED: '退出 企业 失败。',
  BUSINESS_LEAVE_TITLE: '退出 企业',
  BUSINESS_LEAVE_OWNER_HINT: '您是所有者。唯一所有者无法退出,请先指定其他所有者。',
  BUSINESS_LEAVE_MEMBER_HINT: '退出后您将无法查看在该 企业 期间下的订单。',
  BUSINESS_LEAVE: '退出 企业',
  BUSINESS_LEAVE_CONFIRM_TITLE: '确定退出该 企业 吗?',
  BUSINESS_LEAVE_CONFIRM_DESC:
    '您在该 企业 期间下的订单将永久挂在 企业 名下,退出后无法再看到这些订单。',
  BUSINESS_OWNER_CANNOT_REMOVE_SELF: '所有者无法移除自己。',
  BUSINESS_MEMBER_REMOVED: '已移除该成员。',
  BUSINESS_MEMBER_REMOVE_FAILED: '移除成员失败。',
  BUSINESS_MEMBER_REMOVE: '移除',
  BUSINESS_MEMBER_JOINED: '加入时间',
  BUSINESS_ROLE_OWNER: '所有者',
  BUSINESS_ROLE_MEMBER: '成员',
  BUSINESS_MEMBERS_EMPTY_TITLE: '尚无成员',
  BUSINESS_MEMBERS_EMPTY_DESC: '邀请同事一起管理订单。',
  BUSINESS_INVITE_MEMBER: '邀请成员',
  BUSINESS_INVITE_HINT: '向同事的邮箱发送邀请,7 天内可接受。',
  BUSINESS_INVITATION_SEND: '发送邀请',
  BUSINESS_INVITATION_SENDING: '发送中…',
  BUSINESS_INVITATION_SENT: '邀请已发送至 {{email}}。',
  BUSINESS_INVITATION_SEND_FAILED: '发送邀请失败。',
  BUSINESS_INVITATION_REVOKE: '撤销',
  BUSINESS_INVITATION_REVOKED: '邀请已撤销。',
  BUSINESS_INVITATION_REVOKE_FAILED: '撤销邀请失败。',
  BUSINESS_INVITATION_EXPIRES: '过期',
  BUSINESS_INVITATIONS_EMPTY: '暂无邀请记录。',
  BUSINESS_INVITATION_STATUS_PENDING: '待接受',
  BUSINESS_INVITATION_STATUS_ACCEPTED: '已接受',
  BUSINESS_INVITATION_STATUS_EXPIRED: '已过期',
  BUSINESS_INVITATION_STATUS_REVOKED: '已撤销',
  BUSINESS_OWNER_ONLY_TITLE: '仅所有者可见',
  BUSINESS_OWNER_ONLY_DESC: '仅 企业 所有者可以管理邀请。',
  PRODUCT_NOT_AVAILABLE_FOR_IDENTITY: '此商品不向您当前的账户类型销售。',
};

export default buyerZh;
